import Papa from "papaparse";

export function parseFile(fileContent: string) {
  // Parse the file content using PapaParse
  const parsedData = Papa.parse<string>(fileContent, {
    header: false,
    skipEmptyLines: true,
  });

  return parsedData.data.map((row) => row[0]);
}
